<template>
  <div class="home-2 no-scrollbar" :class="theme">

    <div v-if="isStaging" class="triangle-dev" />

    <div class="secret-top-left" @click="showWorkPanel(true)" />

    <div class="secret-top-center" @click="gotoTransactions" />

    <div v-show="isShowMobile" class="user-details" @click="isShowMobile = false">
      <p style="margin-bottom: 5px" @click="setProfileName">
        <span class="link">{{ fullName }}</span>
      </p>
      <p style="font-weight: 500">
        {{ userMobile }}
        <button class="delete is-large is-pulled-right" style="opacity: 0.6" />
      </p>
    </div>

    <!-- <HomeTopBar v-show="isScrollTop && isWorker" @work="showWorkPanel" /> -->

    <div ref="scrollable" class="main no-scrollbar gpu-accelerated" :class="theme" v-on:scroll.passive="onScroll">
      <div class="top-pattern">
        <!-- <img src="/img/home2/home-dots-pattern.png" /> -->
      </div>
      <span class="toggle" @click="$store.commit('toggleTheme')">
        <img src="/img/home2/half.svg" />
      </span>

      <div v-if="isLoggedIn">
        <a v-if="isWorker" class="button manage" @click="showWorkPanel(false)">
          {{ $t("home2.work") }}
          <i v-if="showWorkerBadge" class="badge pulse-blue" style="margin-top: -24px; right: -4px" />
        </a>

        <div class="profile">
          <!-- <span v-if="!noProfilePic" class="edit-pic" @click="setProfilePic">
            <i class="fa fa-question" />
          </span> -->
          <img v-webp="$store.getters.profilePic" @error="fallbackProfPic" @click="gotoDelay('profile?tab=user')" />
          <div class="hi is-pointer" :class="theme">
            <p class="is-uppercase has-text-weight-bold single-line" style="max-width: 50vw" @click="showMobile">
              {{ $t("home2.hi") }}
              <span class="name">
                <span v-if="userName">{{ userName }}</span>
                <span v-else @click="setProfileName">
                  <span class="link">{{ $t("home2.unknown") }}</span>
                  <i class="fa fa-pencil-alt has-text-info" style="text-shadow: 0 0 1px black; margin-left: 6px" />
                </span>
              </span>
            </p>
            <p @click="showAddressPanel" style="padding-bottom: 20px">
              {{ city }}&nbsp;
              <i class="fa fa-caret-down fa-lg" :class="{ 'has-text-danger': $store.state.fakeGPS }" />
            </p>
          </div>
        </div>
        <!-- </div> -->
        <!-- else: not worker -->
        <!-- <div v-else class="not-worker" :class="theme">
          <p class="is-uppercase has-text-weight-bold single-line" style="max-width: 50vw" @click="showMobile">
            {{ $t("home2.hi") }}
            <span class="name">
              <span v-if="userName">{{ userName }}</span>
              <span v-else @click="setProfileName">
                <span class="link">{{ $t("home2.unknown") }}</span>
                <i class="fa fa-pencil-alt has-text-info" style="text-shadow: 0 0 1px black; margin-left: 6px" />
              </span>
            </span>
          </p>
          <p @click="showAddressPanel" style="padding-bottom: 20px">
              {{ city }}&nbsp;
              <i class="fa fa-caret-down fa-lg" :class="{ 'has-text-danger': $store.state.fakeGPS }" />
            </p>
        </div> -->
      </div>
      <!-- else: Not logged in -->
      <div v-else>
        <div v-if="isPicante()">
          <svgicon icon="picante" width="180" height="90" color="#00ffbd" :fill="true" @click="goto('profile?tab=user')">
          </svgicon>
        </div>
        <div v-else>
          <svgicon icon="tuk-word" width="90" height="90" color="#1f1b24" :fill="true" @click="goto('profile?tab=user')">
          </svgicon>
        </div>
        <a class="button is-outlined is-rounded login" @click="login">{{
          $t("home2.log-in")
        }}</a>
      </div>

      <div class="control has-icons-left has-icons-right search" :class="theme">
        <span class="icon is-left" style="margin: 4px">
          <i class="fa fa-search has-text-warning fa-lg" />
        </span>
        <input class="input is-medium" type="text" :placeholder="searchPlaceholder" @click="goto('search')" readonly />
        <span v-if="!isIOSApp()" class="icon is-right is-pointer" style="pointer-events: initial"
          @click="openQRCodeScanner">
          <i class="fa fa-qrcode has-text-warning fa-lg" />
        </span>
      </div>

      <div :key="z">
        <HomeMainButtons3 />

        <div v-if="hasFavorites">
          <HomeAds @favorite="goto('search')" />
        </div>

        <HomeList v-for="i in 12" :key="'list' + i" :list="i.toString()" />
        <!-- <HomeList :list="'1'" /> -->
      </div>

      <div v-if="!hasFavorites">
        <HomeAds @favorite="goto('search')" />
      </div>

      <HomeList :list="'Business'" />

      <div class="secret-buttons">
        <div class="secret-btn" @click="$store.commit('toggleTheme')" />
        <div class="secret-btn" @click="clearCacheAndReload" />
      </div>
    </div>

    <AddressPanel />
    <WorkPanel />
    <!-- <MessagesPanel /> -->
    <SpecialHomeMenu />
    <WelcomeToPanel />

    <!-- <footer class="bottom no-scrollbar" :class="{ 'bottom-pattern': !isIOSApp() }"> -->
    <footer class="bottom no-scrollbar">
      <!-- <div class="column" @click="showMessagesPanel">
        <img
          src="/img/home2/bottom_messages.png"
          style="height: 35px; margin-bottom: -5px"
        />
        <p>{{ $t("home2.messages") }}</p>
      </div> -->
      <div class="column" @click="goto('profile?tab=user')">
        <img src="/img/home2/settings.png" />
        <p>{{ $t("home2.settings") }}</p>
      </div>
      <div class="column" @click="gotoOrders">
        <i v-if="showCustomerBadge" class="badge pulse-gold" />
        <img src="/img/home2/bottom_orders.png" />
        <p>{{ $t("home2.orders") }}</p>
      </div>
      <div v-if="$store.getters.getStartURL === 'super_ops'" class="column" @click="goto('super_ops')">
        <img src="/img/home2/list.png" />
        <p>Ops</p>
      </div>
      <div v-else-if="$store.getters.isDriver" class="column" @click="goto('driver')">
        <img src="/img/home2/bottom_driver.png" />
        <p>{{ $t("driver.driver") }}</p>
      </div>
      <div v-if="hasMagic" class="column" @click="showSecretMenu">
        <img src="/img/home2/toucan.svg" />
        <p>{{ $t("special") }}</p>
      </div>
    </footer>
  </div>
</template>

<script>
import EventBus from "../eventBus.js";
import SpecialHomeMenu from "@/components/SpecialHomeMenu.vue";
// import MessagesPanel from "@/components/MessagesPanel.vue";
import WorkPanel from "@/components/WorkPanel.vue";
import AddressPanel from "@/components/AddressPanel.vue";
import WelcomeToPanel from "@/components/WelcomeToPanel.vue";
import HomeMainButtons3 from "@/components/HomeMainButtons3.vue";
import HomeAds from "@/components/HomeAds.vue";
// import HomeTopBar from "@/components/HomeTopBar.vue";
// import HomeSearch from "@/components/HomeSearch.vue";
import HomeList from "@/components/HomeList.vue";

export default {
  name: "Home2",
  components: {
    SpecialHomeMenu,
    // MessagesPanel,
    WorkPanel,
    AddressPanel,
    WelcomeToPanel,
    HomeMainButtons3,
    HomeAds,
    // HomeTopBar,
    // HomeSearch,
    HomeList,
  },
  data() {
    return {
      // isSearch: false,
      isScrollTop: false,
      isShowMobile: false,
      searchPlaceholder: this.$t("home2.search"),
      rectangleHeight: 473,
      z: 0,
    };
  },
  computed: {
    hasFavorites() {
      return this.$store.getters.getFavoriteEateries.length;
    },
    isStaging() {
      return !this.isProduction();
    },
    hasMagic() {
      return this.$store.getters.isMagical;
    },
    theme() {
      return this.$store.state.theme;
    },
    isLoggedIn() {
      return this.$store.getters.isLoggedIn;
    },
    fullName() {
      return this.$store.getters.realName;
    },
    userName() {
      // return null;
      var name = this.$store.getters.realName;
      if (!name) return null; //this.$t("home2.unknown");
      if (name.length < 10) return name;
      name = name.split(" ")[0];
      if (name.length < 10) return name;
      return this.shortenString(name, 10);
    },
    userMobile() {
      return this.$store.getters.phoneNumber;
    },
    city() {
      if (!this.$store.state.region || this.$store.state.region === "") {
        return this.$t("set-location");
      }
      return this.translateRegion(this.$store.state.region);
    },
    isWorker() {
      return this.$store.getters.isWorker;
      // var roles = this.$store.getters.getWorkerRoles;
      // if (!roles || roles.length === 0) return false;
      // return true;
    },
    // noProfilePic() {
    //   // return true; // for dev
    //   if (!this.$store.state.user) return false;
    //   return !this.$store.state.user.profile_pic_url; // true if no pic
    // },
    showCustomerBadge() {
      return this.$store.getters.getOngoingCustomerTransactions.length;
    },
    showWorkerBadge() {
      if (
        this.$store.getters.getOngoingWorkerTransactions.length > 0 ||
        this.$store.state.ongoingCommerceAgentTransactions ||
        this.$store.state.ongoingLogisticsAgentTransactions
      ) {
        return true;
      }
      return false;
    },
  },
  mounted() {
    // this.$e.$on("mounted", () => alert("mounted"));
    // this.$e.$emit("mounted"); // <<< new event bus syntax with global prototype
    this.cycleSearchPlaceholder();

    this.$cookies.set("full_path", this.$route.fullPath);
    this.checkLangQuery();
    this.checkRegionQuery();
    this.checkFCMQuery();
    var query = `query [${JSON.stringify(this.$route.query)}]`;
    EventBus.$emit("DEBUG", query);
    // this.checkStartURL(); // check if user has another preferred start_url
    if (this.isPicante()) {
      this.$store.commit("toggleTheme", "dark");
      this.updateMarts();
      this.$nextTick(() => (this.z += 1));
    }
  },
  activated() {
    this.isScrollTop = false;
    this.checkVersion();
    // this.checkMessages();
    this.updateAllWorkflows();
    this.updateMarts();
    this.checkWelcomeTo();
    this.refreshTransport();
    this.updateTrips(false);
    this.$store.commit("selectDriver", null); // turn off dispatch mode
  },
  deactivated() {
    this.isShowMobile = false;
  },
  beforeRouteLeave(to, from, next) {
    var ref = this.$root.$refs.SuperRecentTransactions;
    // console.log("beforeRouteLeave", ref);
    if (ref && !to.hash) {
      // hack check for hash #force
      ref.handleBackButton();
      next(false);
      return; // don't leave if handled
    }
    next();
  },
  methods: {
    gotoTransactions() {
      if (!this.isSuperUser()) return;
      this.warningToast("🔮", "top", 800);
      this.goto("super_ops");
    },
    onScroll() {
      if (!this.$refs.scrollable) return;
      var scrollTop = this.$refs.scrollable.scrollTop;
      this.rectangleHeight = 473 + scrollTop;
      if (scrollTop > 100) this.isScrollTop = true;
      else this.isScrollTop = false;
    },
    openChrome() {
      var url = `intent://tukapp.co#Intent;scheme=https;package=com.android.chrome;end`;
      window.location.href = url; // window.open(url, "_target");
    },
    closeHomePanels() {
      EventBus.$emit("CLOSE_HOME_PANELS");
    },
    fallbackProfPic(e) {
      e.target.src = this.$store.state.errorProfilePic; // this.$store.state.menuItemPlaceholderPic;
    },
    setProfilePic() {
      this.goto("profile?tab=user");
      this.checkProfilePic();
    },
    setProfileName() {
      this.goto("profile?tab=user");
      this.setName();
    },
    showMobile() {
      this.isShowMobile = true;
    },
    showSecretMenu() {
      this.closeHomePanels();
      this.showComponent(".special-home-menu-component");
    },
    // showMessagesPanel() {
    //   this.log("messages_panel");
    //   this.closeHomePanels();
    //   this.showComponent(".messages-panel-component");
    // },
    showAddressPanel() {
      this.log("address_panel");
      EventBus.$emit("OPEN_ADDRESS_PANEL");
      this.showComponent(".address-panel-component");
    },
    deliveryDriverHack(roles) {
      var roleNames = roles.map((r) => r.role_name);
      var arr = [...new Set(roleNames)]; // set of distinct role names
      if (arr.length !== 2) return false;
      return (
        arr.find((n) => n === "Driver") &&
        arr.find((n) => n === "Delivery Driver")
      );
    },
    showWorkPanel(force) {
      this.requestPersistedStoragePermission();
      this.log("work_panel");
      if (force) return this.showComponent(".work-panel-component");

      // if not force then check roles first
      var roles = this.$store.getters.getWorkerRoles;
      if (!roles || !roles.length) return; // this shouldn't happen
      if (this.deliveryDriverHack(roles)) {
        this.goto("driver");
        return;
      }
      if (roles.length === 2) {
        // handle special case for dispatcher (will also have driver role)
        if (this.$store.getters.isDispatcher) {
          this.goto("fleet_dispatcher"); // "tuktuk" or "fleet_dispatcher" ??
          return;
        }
        // handle special case for delivery driver (will also have driver role)
        // if (this.$store.getters.isDeliveryDriver) this.goto("driver");
      }
      var roleNames = new Set(roles.map((r) => r.role_name));
      // console.log("roleNames", roleNames, roleNames.size);
      if (roleNames.size === 1 && roleNames.has("Commerce Agent")) {
        this.goto("ecommerce");
        return;
      }
      if (roles.length > 1) return this.showComponent(".work-panel-component"); // show all roles if >1
      var name = roles[0].role_name; // otherwise user has single role, so see what it is and go direct
      var path = "";
      if (name === "Superuser") path = "control";
      if (name === "Driver") path = "driver"; //"tuktuk";
      if (name === "Dispatcher") path = "tuktuk"; // TODO dispatcher page, fleet_manager page?
      if (name === "Delivery Driver") path = "driver"; // "tuktuk";
      if (name === "Delivery Dispatcher") path = "delivery";
      if (name === "Logistics Agent") path = "logistics_fleet";
      if (name === "Agent") path = "tuktuk";
      if (name === "Commerce Agent") {
        path = "/ecommerce"; // default
        var role = this.$store.getters.getCommerceAgentRole;
        if (role.workflow && role.workflow.data) {
          if (role.workflow.data.ui === "commerce") path = "/commerce";
        }
      }
      this.goto(path); //this.gotoDelay(path);
    },
    login() {
      EventBus.$emit("OPEN_LOGIN_SMS_MODAL"); // optional payload: {msg: "Welcome to TUK", callback: "SOMETHING"}
    },
    gotoOrders() {
      this.closeHomePanels();
      var msg = this.$t("login.login-to-see-your-orders"); // this doesn't do anything, msg not used for sms login
      if (!this.smsLoginOkay(msg)) return;
      // this.gotoDelay("/profile?tab=trips&tab2=Upcoming");
      this.gotoDelay("/orders?tab=ongoing");
    },
    openHelp() {
      this.log("open_help");
      var url = `https://tukapp.freshdesk.com/support/solutions`;
      setTimeout(() => window.open(url, "_blank"), 500);
    },
    openLogisticsForm() {
      this.log("open_logistics");
      var url = this.$t("logistics.type-form-url");
      setTimeout(() => window.open(url, "_blank"), 500);
    },
    openToursForm() {
      this.log("open_tours");
      var url = this.$t("tours.type-form-url"); // https://tukapp.typeform.com/to/c0ZK0Jnr
      // var url = `https://tukapp.typeform.com/to/THUq5DWN`; //this.$t("logistics.type-form-url");
      setTimeout(() => window.open(url, "_blank"), 500);
    },
    openQRCodeScanner() {
      this.log("open_scanner");
      this.closeHomePanels();
      this.goto("/qrscanner");
    },
    cycleSearchPlaceholder() {
      var strings = [
        "search-restaurants",
        "search-food",
        "search-shops",
        // "search-services",
        // "search-transport",
        // "search-anything",
        "search",
      ]; // blank at end
      var i = 0;
      setInterval(() => {
        i += 1;
        if (i >= strings.length) i = 0;
        this.searchPlaceholder = this.$t(`home2.${strings[i]}`);
      }, 1500);
    },
    // checkStartURL() {
    //   var startURL = this.$store.getters.getStartURL;
    //   this.console(`check startURL [ ${startURL} ]`, this.$route.path);
    //   if (this.$route.path === "/" && startURL) this.goto(startURL);
    // },
    checkWelcomeTo() {
      if (this.debounce("welcomeTo", 60 * 60 * 24)) return;
      if (!this.$store.state.welcomeTo) return; // return if false
      this.$store.commit("setWelcomeTo", false); // now set false
      this.$store
        .dispatch("reverseGeocode", this.$store.state.userState)
        .then((res) => {
          this.console("reverseGeocode", res);
          if (!res.data || !res.data.address) return;
          if (!res.data.address.country) return; // can't determin country
          // this.showWelcomeToMessage(res.data.address.country);
          var o = res.data.address;
          var payload = { code: o.country_code, name: o.country };
          this.showComponent(".welcome-to-panel-component");
          EventBus.$emit("SHOW_WELCOME_TO", payload);
        })
        .catch((err) => console.error("reverseGeocode error", err));
    },
  },
};
</script>

<style scoped>
.home-2 {
  /* background-color: #f0be45; */
  background-color: #fafafa;
  height: 100vh;
  width: 100vw;
  max-height: 100vh;
  max-width: 100vw;
  overflow: hidden;
  /* overscroll-behavior: contain; */
  /* height: -webkit-fill-available; */
  /* max-height: -webkit-fill-available; */
}

.dark.home-2 {
  /* background-color: #1c37bd; */
  /* background-color: #1f1b24; */
  background-color: black;
}

svg {
  /* margin-top: -40px; */
  position: relative;
  margin-top: -40px;
  /* margin-top: 0; */
  z-index: 3;
  float: left;
  /* filter: drop-shadow(1px 1px 1px rgba(0, 0, 0, 0.35)); */
}

.login {
  float: right;
  font-weight: 800;
  /* border: 2px solid white; */
  border: 2px solid #1f1b24;
  box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.35);
  background-color: #fafafa00;
  color: #1f1b24;
}

/* .dark .login {
  color: #1f1b24;
} */
.manage {
  /* float: right; */
  position: absolute;
  right: 40px;
  /* right: 10vw; */
  /* top: 10vh; */
  top: 80px;
  font-weight: 600;
  border: 0px;
  /* box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.35); */
  background-color: rgba(255, 255, 255, 0.35);
  /* background-color: rgba(0, 0, 0, 0.15); */
  /* background-color: #f0be45; */
  /* color: white; */
  /* padding: 0 10.5px; */
  padding: 0 10px;
  border: 2px solid #1f1b24;
  /* box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.35); */
  background-color: #fafafa00;
  color: #1f1b24;
  /* border-radius: 35%; */
  border-radius: 30px;
}

.secret-top-center {
  position: absolute;
  top: 0;
  left: calc(50vw - 18px);
  padding: 20px 36px;
  z-index: 2;
}

.secret-top-left {
  position: absolute;
  top: 0;
  left: 0;
  padding: 25px;
  z-index: 2;
}

.secret-top-right {
  position: absolute;
  top: 0;
  right: 36px;
  padding: 36px;
  z-index: 2;
  /* background-color: red; */
}

.secret-bottom-left {
  position: absolute;
  bottom: 100px;
  left: 0;
  padding: 25px;
  z-index: 9;
}

.not-worker {
  position: relative;
  /* width: 100vw; */
  /* padding: 100px; */
  /* z-index: 9999; */
  /* background-color: green; */
  color: white;
}

.profile {
  position: relative;
  margin-top: -40px;
  float: left;
  /* z-index: 3; */
}

.profile img {
  object-fit: cover;
  border-radius: 50%;
  /* border: 7px solid #f5d252;
  background-color: #f5d252; */
  /* border: 3px solid palevioletred; */
  border: 3px solid #ffc800;
  background-color: #ffc800;
  /* border: 1px solid white; */
  /* box-shadow: 0 0 0 7pt #f5d252; */
  height: 80px;
  width: 80px;
}

.dark .profile img {
  /* border: 7px solid #2693da;
  background-color: #2693da; */
  /* border: 3px solid #1c37bd; */
  /* background-color: #1c37bd; */
  background-color: var(--cyrpto-secondary);
  border: 3px solid var(--crypto-secondary-light);
}

.dark .list-item:not(:last-child) {
  border-bottom: 1px solid #dbdbdb27;
}

.edit-pic {
  position: absolute;
  padding: 33px;
  /* top: calc(10vh - 49px); */
  /* left: 41px; */
  top: -10px;
  left: 1px;
  color: hotpink;
  text-shadow: 1px 0 1px black;
}

.hi {
  display: inline-block;
  position: relative;
  top: -40px;
  padding-left: 10px;
  text-align: left;
  /* color: #444; */
}

.dark .hi {
  color: white;
}

.search {
  position: relative;
  margin-top: 70px;
}

.input {
  /* box-shadow: 4px 4px 10px rgba(0, 0, 0, 0.35); */
  /* box-shadow: 0px 0px 1px rgba(0, 0, 0, 0.35); */
  background-color: rgba(255, 255, 255, 0.9);
  border-color: white;
}

input:focus {
  border-color: #f5d252;
  border-radius: 5px;
}

.main {
  position: relative;
  height: 100vh;
  /* padding: 10vh 10vw; */
  /* padding: 10vh 30px; */
  padding: 80px 30px;
  padding-bottom: 100px;
  overflow-y: scroll;
  /* trying to fix desktop */
  overflow-x: hidden;
  max-width: 500px;
  margin: auto;
  z-index: 1;
  /* border: 6px solid #444;
  border-radius: 20px; */
}

.name {
  margin: 0 3px;
}

.btns {
  font-weight: 700;
  /* has-text-weight-bold */
  /* max-height: 300px;
  overflow: scroll; */
}

.btn {
  padding: 15px;
  padding-top: 20px;
  margin-top: 20px;
  /* height: 15vh; */
  /* height: 120px; */
  /* width: 100%; */
  /* background-color: #fff; */
  background-color: rgba(255, 255, 255, 0.9);
  border-radius: 20px;
  box-shadow: 4px 4px 10px rgba(0, 0, 0, 0.35);
}

.btn img {
  position: relative;
  height: 60px;
  width: auto;
  z-index: 2;
  filter: drop-shadow(1px 1px 1px rgba(0, 0, 0, 0.35));
}

.btn p {
  position: relative;
  z-index: 2;
  /* text-shadow: 1px 0px 1px rgba(0, 0, 0, 0.35); */
}

.bottom {
  position: absolute;
  bottom: 0;
  height: 80px;
  min-width: 100vw;
  width: 100%;
  /* background-color: #fff; */
  /* background-color: rgba(255, 255, 255, 0.97); */
  background-color: #ffc800;
  background: linear-gradient(0deg,
      #ffc800 0%,
      white 100%);
  /* padding-bottom: 20px; */
  padding-top: 12px;
  padding-left: 10px;
  padding-right: 10px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.35);
  z-index: 3;
  overflow-x: auto;
  overflow-y: hidden;
  white-space: nowrap;
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
}

.bottom-pattern {
  background-image: url("/img/home2/home-dots-pattern.png");
  background-size: contain;
  background-position: center;
}

.bottom .column {
  display: inline-block;
  width: 85px;
  padding: 0 0;
}

.bottom .column:active {
  transform: scaleY(0.95);
}

.bottom img {
  height: 35px;
  margin-bottom: -5px;
}

.manage:active {
  transform: scaleY(0.95);
}

.dark .bottom img {
  /* background-color: rgba(255, 255, 255, 0.8);
  border-radius: 6px;
  padding: 2px; */
  filter: invert(100%) sepia(33%) saturate(0%) hue-rotate(319deg) brightness(107%) contrast(101%);
}

.circle {
  background-color: #f5d252;
  border-radius: 50%;
  position: fixed;
}

.dark .circle {
  /* background-color: rgb(48, 48, 211); */
  background-color: #2693da;
}

.dark .rectangle {
  background-color: rgb(59, 59, 59);
}

body.noscroll {
  position: fixed;
  overflow: hidden;
}

/* .wiggle:active {
  transform: rotate(330deg);
  -webkit-transform: rotate(330deg);
  -ms-transform: rotate(330deg);
} */
.no-scrollbar::-webkit-scrollbar {
  display: none;
}

.fa-cog:active {
  font-size: 1.5em;
}

.profile img:active {
  /* -webkit-transform: rotate(330deg) scale(1.5);
  -ms-transform: rotate(330deg) scale(1.5);
  transform: rotate(330deg) scale(1.5); */
  transform: scaleY(0.95);
}

.mobile {
  color: white;
  font-weight: 900;
}

.user-details {
  position: absolute;
  text-align: left;
  left: 0px;
  top: -2px;
  width: 100vw;
  font-size: 1.2em;
  background-color: rgba(255, 213, 0, 0.95);
  padding: 12px;
  padding-bottom: 10px;
  /* border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px; */
  z-index: 3;
  box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.5);
}

.dark .user-details {
  background-color: rgb(48, 48, 211);
  color: white;
}

.search-result {
  position: absolute;
  z-index: 5;
  width: 80vw;
  /* background-color: rgba(255, 255, 255, 0.97); */
  background-color: #f5d252;
  box-shadow: 0 2px 2px 4px rgba(0, 0, 0, 0.5);
}

.list-item {
  text-align: left;
  width: 80vw;
  background-color: #feeaa4;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.dark .btn,
.dark .input,
.dark .manage {
  /* background-color: rgba(17, 34, 51, 0.8); */
  background-color: #1f1b24;
  color: white;
}

.dark .manage {
  border: 2px solid white;
  border: 2px solid var(--crypto-secondary-light);
}

.dark .bottom {
  /* background-color: rgba(17, 34, 51, 0.97); */
  /* background-color: #1f1b24; */
  background-color: var(--crypto-primary);
  color: white;
  background: linear-gradient(0deg,
      var(--crypto-primary) 0%,
      var(--crypto-secondary) 100%);
}

.dark input::-webkit-input-placeholder {
  /* color: #2693da !important; */
  color: #666 !important;
}

.dark input {
  /* border-color: #123; */
  border-color: rgba(255, 255, 255, 0);
}

.dark input:focus {
  /* border-color: #209cee; */
  border-color: #2693da;
}

.dark .fa-search,
.dark .fa-qrcode {
  /* color: #2693da !important; */
  /* color: #1c37bd !important; */
  color: var(--crypto-secondary-light) !important;
}

/* .dark .search-result, */
.dark .list-item {
  /* background-color: rgba(17, 34, 51, 0.97); */
  background-color: #1c37bd;
  color: white;
}

.badge {
  position: absolute;
  margin-top: -2px;
  margin-left: 25px;
  background-color: #ff3860 !important;
  border-radius: 50%;
  padding: 6px;
  /* right: 40px;
  top: 10vh; */
}

@keyframes shadow-pulse-gold {
  0% {
    box-shadow: 0 0 0 0px rgba(247, 211, 8, 0.95);
  }

  100% {
    box-shadow: 0 0 0 5px rgba(247, 211, 8, 0.5);
  }
}

@keyframes shadow-pulse-blue {
  0% {
    box-shadow: 0 0 0 0px rgba(0, 255, 255, 0.95);
  }

  100% {
    box-shadow: 0 0 0 5px rgba(0, 255, 255, 0.5);
  }
}

.pulse-gold {
  animation: shadow-pulse-gold 1s infinite;
}

.pulse-blue {
  animation: shadow-pulse-blue 1s infinite;
}

.single-line {
  white-space: nowrap;
  overflow: hidden;
  /* display: inline-block; */
}

.link {
  border-bottom: 1px #bbb dotted;
}

.fa-caret-down {
  opacity: 0.8;
}

/* "/img/home2/settings.png" */
.top-pattern img {
  object-fit: cover;
  height: 100%;
  width: 100%;
  /* overflow: hidden; */
  /* border-bottom-left-radius: 10%;
  border-bottom-right-radius: 10%; */
}

.top-pattern {
  position: absolute;
  max-width: 500px;
  margin: auto;
  /* background-image: url("/img/home2/home-dots-pattern.png"); */
  /* background: rgb(255, 134, 0); */
  /* background-color: rgba(255, 194, 0, 1); */
  background-color: #ffc800;
  /* background: linear-gradient(0deg,
      rgba(255, 134, 0, 0.6) 0%,
      rgba(255, 194, 0, 1) 100%); */
  background: linear-gradient(0deg,
      #ffc800 0%,
      white 100%);
  /* background-color: gold; */
  /* background-color: rgba(255, 182, 193, 0.5); */
  top: 0;
  left: 0;
  /* height: 420px; */
  height: 328px;
  width: 100vw;
  /* border-bottom-left-radius: 10%;
  border-bottom-right-radius: 10%; */
}

.dark .top-pattern {
  /* background-color: #1c37bd !important; */
  background-color: var(--crypto-primary) !important;

  background: linear-gradient(0deg,
      var(--crypto-primary) 0%,
      var(--crypto-secondary) 100%);
}

.rectangle {
  position: fixed;
  /* max-width: 500px; */
  margin: auto;
  background-color: #fff5d1;
  /* background-color: rgba(255, 182, 193, 0.5); */
  top: 0;
  /* height: 473px; */
  width: 100vw;
}

.triangle {
  position: absolute;
  z-index: 0;
  left: -100px;
  top: 73px;
  width: 0;
  height: 0;
  border-bottom: 400px solid #ffc800;
  /* border-bottom: 400px solid lightblue; */
  border-left: 900px solid transparent;
}

.triangle-dev {
  position: absolute;
  z-index: 2;
  left: 0px;
  top: 0px;
  width: 0;
  height: 0;
  /* border-top: 40px solid #ffc800; */
  border-top: 40px solid #1c37bd;
  /* border-top: 40px solid snow; */
  border-right: 40px solid transparent;
}

.dark .triangle {
  border-bottom: 400px solid #1c37bd;
}

.dark .triangle-dev {
  /* border-top: 40px solid #1c37bd; */
  border-top: 40px solid #ffc800;
}

.secret-buttons {
  display: flex;
  margin-top: 30px;
}

.secret-btn {
  flex: 1;
  padding: 40px;
  /* border: 1px solid rgba(255, 255, 255, 0.01); */
}

.toggle {
  position: absolute;
  right: 0;
  top: 0;
  padding: 12px;
  opacity: 0.5;
  z-index: 2;
}

.toggle img {
  height: 20px;
}

/* // Light Yellow: #fff5d1
// Darker Yellow: #ffc800
// Gray Background at bottom: #fafafa */
</style>




